<!-- 超级管理员-素质报告 -->
<template>
  <div style="width: 100%; height: 100%">
    <div class="header">
      <span
        >应用{{
          this.$route.path.split("/")[1] !== "admin" ? "中心" : ""
        }}／素质报告<span v-if="$store.state.user.role !== 'school_admin'"
          >／报告模板（{{ stageName }}）</span
        ></span
      >
    </div>
    <div class="main-content">
      <div class="subject scroll">
        <el-select
          placeholder="请选择"
          v-model="grade"
          style="width: 100%; margin-bottom: 10px"
          @change="changeGrade"
        >
          <el-option
            v-for="item in gradeOption"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <div style="height: 40px; line-height: 40px">
          <span class="basic-subject">基础学科</span>
          <div
            style="float: right"
            v-if="Number(this.$route.query.stage) === 1"
          >
            <el-button
              v-if="
                !$store.state.user.level && Number($route.query.stage) === 1
              "
              type="text"
              @click="manageSecondSubject"
              >二级学科管理</el-button
            >
          </div>
        </div>
        <div style="width: 100%; margin-top: 10px">
          <div
            style="margin-bottom: 10px"
            v-for="(item, index) in subjects"
            :key="item.value"
          >
            <div v-if="index < subjects.length && index % 2 === 0">
              <el-button size="medium" style="width: calc(50% - 10px)">
                <span
                  class="text-ellipsis"
                  :title="subjects[index] && subjects[index].name"
                  >{{ subjects[index] && subjects[index].name }}</span
                ></el-button
              >
              <el-button
                size="medium"
                style="width: calc(50% - 10px)"
                v-if="subjects[index + 1]"
                ><span
                  class="text-ellipsis"
                  :title="subjects[index + 1] && subjects[index + 1].name"
                  >{{ subjects[index + 1] && subjects[index + 1].name }}</span
                ></el-button
              >
            </div>
          </div>
        </div>
        <template v-if="$store.state.user.role === 'school_admin' || $store.state.user.role === 'teacher'">
          <div style="height: 40px; line-height: 40px; margin-top: 20px">
            <span class="basic-subject">校本学科</span>
          </div>
          <div>
            <div
              style="margin-bottom: 10px"
              v-for="(item, index) in basicSub"
              :key="item.value"
            >
              <div v-if="index < basicSub.length && index % 2 === 0">
                <el-button size="medium" style="width: calc(50% - 10px)">
                  <span
                    class="text-ellipsis"
                    :title="basicSub[index] && basicSub[index].name"
                    >{{ basicSub[index] && basicSub[index].name }}</span
                  ></el-button
                >
                <el-button
                  size="medium"
                  style="width: calc(50% - 10px)"
                  v-if="basicSub[index + 1]"
                  ><span
                    class="text-ellipsis"
                    :title="basicSub[index + 1] && basicSub[index + 1].name"
                    >{{ basicSub[index + 1] && basicSub[index + 1].name }}</span
                  ></el-button
                >
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="template-container">
        <div class="template-div">
          <span class="template-title"
            >{{
              _.filter(gradeOption, { value: grade })[0] &&
              _.filter(gradeOption, { value: grade })[0].name
            }}学生素质报告单模版</span
          >
        </div>
        <div style="padding: 0 25px; height: calc(42cm + 60px)">
          <component
            :is="higherTemplate"
            :reportData="reportData"
            :subjects="subjects"
            :template="true"
          ></component>
        </div>
      </div>
    </div>

    <second-subject
      :visible.sync="editorVisible"
      :secondSubjects="secondSubjects"
      :grade="grade"
    ></second-subject>
  </div>
</template>

<script>
import _ from 'lodash'
import HigherTemplate from '@/components/common/HigherTemplate'
import PrimaryTemplate from '@/components/common/PrimaryTemplate'
import SecondSubject from '@/components/common/SecondSubject'
export default {
  props: [],

  components: {
    'higher-template': HigherTemplate,
    'primary-template': PrimaryTemplate,
    'second-subject': SecondSubject
  },

  data () {
    return {
      grade: null,
      grades: [
        {
          stage: 1,
          value: [
            {
              name: '一年级',
              value: 1
            },
            {
              name: '二年级',
              value: 2
            },
            {
              name: '三年级',
              value: 3
            },
            {
              name: '四年级',
              value: 4
            },
            {
              name: '五年级',
              value: 5
            },
            {
              name: '六年级',
              value: 6
            }
          ]
        },
        {
          stage: 2,
          value: [
            {
              name: '初一年级',
              value: 7
            },
            {
              name: '初二年级',
              value: 8
            },
            {
              name: '初三年级',
              value: 9
            }
          ]
        },
        {
          stage: 3,
          value: [
            {
              name: '高一年级',
              value: 10
            },
            {
              name: '高二年级',
              value: 11
            },
            {
              name: '高三年级',
              value: 12
            }
          ]
        }
      ],
      subjects: [],
      basicSub: [],
      higherTemplate: null,
      editorVisible: false,
      secondSubjects: [],
      reportData: {
        secondTerm: true,
        schoolTerm: '2017-2018学年第二学期',
        studentName: '',
        idCard: null,
        className: '',
        schoolName: '学校名称',
        termStartYear: '',
        termEndYear: '',
        basicSubjectList: [
          { 'name': '道德与法治', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '语文', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '数学', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '英语', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '物理', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '化学', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '历史', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '体育与健康', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '音乐', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '美术', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '信息技术', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '劳动与技术', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '研究性学习', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '社区服务', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] },
          { 'name': '社区实践', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀', 'secondarySubjects': [], 'sportsArtSubjects': [] }
        ],
        featureSubjectList: [
          { 'name': '专题一', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀' },
          { 'name': '专题二', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀' },
          { 'name': '专题三', 'normal': '优秀', 'midTerm': '优秀', 'terminal': '优秀', 'term': '优秀', 'year': '优秀' }
        ],
        totalClassDays: 95,
        sickLeaveDays: 0,
        truancyDays: 0,
        attendClassDays: 95,
        termBeginMonth: 9,
        termBeginDay: 1,
        reportDutyMonth: 8,
        reportDutyDay: 31,
        evalItemList: [
          { 'indicatorsName': '思想品德', 'indicatorsScore': '优秀' },
          { 'indicatorsName': '学业水平', 'indicatorsScore': '优秀' },
          { 'indicatorsName': '身心健康', 'indicatorsScore': '优秀' },
          { 'indicatorsName': '艺术素养', 'indicatorsScore': '优秀' },
          { 'indicatorsName': '社会实践', 'indicatorsScore': '优秀' }
        ],
        evalPointList: [
          {
            content: '关心国内外大事，了解家乡正在进行的重要建设，崇敬杰出人物。',
            score: '优秀'
          },
          {
            content: '尊敬师长，见面主动问好，接受师长教诲，不顶撞师长，体贴孝敬父母。',
            score: '优秀'
          },
          {
            content: '诚实、不说谎，不贪小便宜，知错就改。',
            score: '优秀'
          },
          {
            content: '举止文明，习惯使用日常礼貌用语，不说粗话、脏话，不打架、骂人。',
            score: '优秀'
          },
          {
            content: '知道自己在所属集体中应发挥的作用，能在集体中主动提出自己的观点。',
            score: '优秀'
          },
          {
            content: '困难的事争取做，开了头的事认真做完，不分心，能按跨时1月~1学期的目标计划行动，善始善终。',
            score: '优秀'
          },
          {
            content: '对挫折和失误不灰心，不固执，能分析原因，想方设法战胜与克服。',
            score: '优秀'
          },
          {
            content: '情绪饱满，常见笑容，不为小事生气委屈，能自觉努力控制情绪。',
            score: '优秀'
          },
          {
            content: '能结合自己的表现，说出自己的优点、不足和进步，能具体表达自己努力的决心、计划和步骤。',
            score: '优秀'
          },
          {
            content: '能看到其它同学的优点和成功，取人之长，补己之短，不自卑，不嫉妒。',
            score: '优秀'
          },
          {
            content: '合群，主动和同学共同活动，相互配合完成任务，能通过谦让解释化解交往的矛盾。',
            score: '优秀'
          },
          {
            content: '把学习当作需要，有自己的目标，自定计划，独立按时完成学习等任务，讲求效率，合理安排闲暇活动。',
            score: '优秀'
          },
          {
            content: '爱思索，观察有计划，学习中能提出疑问、考虑学习方法，主动阅读课外知识性书籍，喜爱小制作并有创意。',
            score: '优秀'
          },
          {
            content: '不迟到，不旷课，不逃学，遵守课堂纪律，遵守学校规章。',
            score: '优秀'
          },
          {
            content: '不欺负弱小，关心爱护小同学，积极做公益事情，同情并乐意帮助残疾人和有困难的人。',
            score: '优秀'
          },
          {
            content: '爱惜学习、生活用品，爱惜粮食，爱护庄稼、花木和公物，不挑吃穿，不乱要钱、乱花钱，会节省、计划用钱。',
            score: '优秀'
          },
          {
            content: '注意个人卫生，衣着整洁，不随地吐痰、乱扔杂物，主动维护环境卫生。',
            score: '优秀'
          },
          {
            content: '积极认真进行值日大扫除和校园劳动，积极参加学校组织的社会公益劳动，劳动不怕脏，不怕累。',
            score: '优秀'
          },
          {
            content: '生活基本自理，积极做好力所能及的家务，能较好进行简单生产劳动。',
            score: '优秀'
          },
          {
            content: '会观赏自然风光，初步能区分社会和生活中事物的美丑，能对艺术作品进行简单的赏析。',
            score: '优秀'
          }
        ],
        generalComment: '你渴望学习成绩的进步，为此一如既往地坚持着自己刻苦努力奋发图强的求学原则，所有这些努力也最终换来了丰收的喜悦，尽管你的学习成绩还不够理想，但你有坚定的信念。我相信，成功的花朵在汗水的浇灌中会更加鲜艳。',
        parentComment: '每个人都有优点，也有缺点。你的优点是爱看书，爱问问题，对知识有一种求知的渴望。缺点是任性，爱发脾气，不能听取别人的意见。希望你能改正缺点，发扬优点。老师和爸爸妈妈相信你能做好，也期待你有更大的进步。',
        schoolSeal: '',
        schoolMasterSeal: null,
        teachingDirectorSeal: null,
        moralDirectorSeal: null,
        classTeacherSeal: null,
        physicalVo: null,
        generalCommentVo: null,
        parentCommentVo: null,
        studentCommentVo: null
      }
    }
  },

  watch: {
  },

  computed: {
    _ () {
      return _
    },
    stageName () {
      switch (Number(this.$route.query.stage)) {
        case 1:
          return '小学'
        case 2:
          return '初中'
        case 3:
          return '高中'
      }
    },
    gradeOption () {
      return _.filter(this.grades, { stage: Number(this.$route.query.stage) })[0].value
    }
  },

  mounted () {
    this.initGrade()
    this.initCom()
  },

  methods: {
    initGrade () {
      this.grade = this.gradeOption[0].value
      this.initData(this.grade)
    },

    initData (val) {
      this.$xhrGet(`/acc/grade/${val}/subjects/basic`).then(rs => {
        this.subjects = rs.data
        let clonedSubjects = _.cloneDeep(rs.data)
        this.reportData.basicSubjectList = clonedSubjects.map(row => {
          return {
            ...row,
            'normal': '优秀',
            'midTerm': '优秀',
            'terminal': '优秀',
            'term': '优秀',
            'year': '优秀'
          }
        })
      })
      if (this.$store.state.user.role === 'school_admin' || this.$store.state.user.role === 'teacher') {
        this.$xhrGet(`/acc/grade/${val}/subjects/school`).then(rs => {
          this.basicSub = rs.data
        })
      }
    },

    changeGrade (val) {
      this.initData(val)
    },

    async initCom () {
      this.higherTemplate = Number(this.$route.query.stage) !== 1 ? (await import('../../common/HigherTemplate')).default : (await import('../../common/PrimaryTemplate')).default
    },

    manageSecondSubject () {
      this.$xhrGet(`/acc/grade/${this.grade}/secondary-subjects`).then(rs => {
        this.editorVisible = true
        this.secondSubjects = rs.data.map(row => {
          return {
            ...row,
            available: row.vos.length > 0
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  float: right;
  height: calc(100% - 88px);
  width: calc(100% - 40px);
  padding: 20px;
  background: var(--theme-background);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header:nth-child(1) {
  padding-left: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}
.subject {
  box-sizing: border-box;
  height: 720px;
  max-height: 100%;
  overflow: auto;
  width: 240px;
  padding: 20px;
  float: left;
  background: #fff;
  border-radius: 6px;
}
.template-container {
  box-sizing: border-box;
  height: 100%;
  width: calc(100% - 260px);
  overflow-y: scroll;
  padding: 20px;
  float: right;
  background: #fff;
  border-radius: 4px;
}
.basic-subject {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  position: relative;
}
.basic-subject:after {
  content: "";
  height: 18px;
  border-left: 3px solid var(--theme-color);
  position: absolute;
  left: -20px;
  top: 0;
}
/deep/ .el-button--medium {
  padding: 10px 0;
}
.template-div {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #dce5f4;
}
.template-title {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
}
.first-standard {
  height: 100%;
  padding: 20px;
  border-radius: 4px;
  overflow-y: scroll;
  background: #fff;
}
.text-ellipsis {
  display: inline-block;
  width: calc(100% - 20px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/apply/ReportTemplate.vue